import Project from "../project";

export function calculateProjectDisplayStartDate(project:Project) {

    // try init by value
    if (project.displayStartDate) project.displayStartDate

    // try init by startDate
    if (project.startDate) return project.startDate

    // we always need display dates... this is defualt but it will be redefined if any children...
    return momentDate()

}

export function calculateProjectDisplayEndDate(project: Project) {
    // try init by value
    if (project.displayEndDate) project.displayEndDate

    // try init by startDate
    if (project.endDate) return project.endDate

    // we always need display dates... this is defualt but it will be redefined if any children...
    return project.displayStartDate

}